(function () {

	const sidebar = document.querySelector('.sidebar--categories');
	let timelines = [];


	if (!sidebar) {
		return;
	}

	const categories = [...sidebar.querySelectorAll('.sidebar--category')];
	categories.forEach(function (category, i) {
		let name = category.querySelector('.sidebar--category_name');
		let products = category.querySelector('.sidebar--category_products');


		let timeline = gsap.timeline({
			paused: true,
			onStart: () => category.classList.add('open'),
		});
		timeline.set(products, { height: 0 })
		timeline.to(products, {
			height: "auto",
			display: 'block',
			ease: "power1.out",
			duration: 0.3,
		});
		timelines[i] = timeline;

		if (category.classList.contains('active')) {
			timelines[i].play();
		}

		name.addEventListener('click', function () {
			if (category.classList.contains('open')) {
				category.classList.remove('open')
				timelines[i].reverse();
			} else {
				timelines[i].play();
			}
		});
	});


}());